import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const FileCardSkeleton = () => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
        >
            <Card className="shadow-sm">
                <div className="p-5 space-y-4">
                    {/* Header with Icon, Title, Date and ID */}
                    <div className="flex items-start justify-between gap-3">
                        <div className="flex items-start gap-3 flex-1 min-w-0">
                            {/* Icon */}
                            <Skeleton className="h-10 w-10 rounded-lg flex-shrink-0" />
                            
                            {/* Title and Date */}
                            <div className="flex-1 space-y-2">
                                <Skeleton className="h-5 w-2/3" />
                                <Skeleton className="h-4 w-1/3" />
                            </div>
                        </div>

                        {/* ID on Right */}
                        <Skeleton className="h-8 w-[140px]" />
                    </div>

                    {/* Single Row Grid */}
                    <div className="rounded-lg border border-border overflow-hidden bg-muted/30">
                        <div className="grid grid-cols-2 divide-x divide-border">
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                            <div className="h-11 flex items-center justify-center">
                                <Skeleton className="h-8 w-16" />
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <Skeleton className="h-9 w-full" />
                </div>
            </Card>
        </motion.div>
    );
};
